import React, { useContext, useState } from 'react';
import { PersonContext } from '../providers/Person.jsx';
import Order from './Order.jsx';
import { s } from '../Style.jsx';

const Orders = () => {

    const { authorizing, orders, gettingOrders } = useContext(PersonContext);

    return <>
        <div style={{ ...s.headerBox, marginBottom: 20 }}>
            <div style={s.headerInnerBox}>

                <h1 style={{ marginBottom: 0 }}><i className="fas fa-receipt"></i> Orders</h1>
                <span style={{ fontSize: 14 }}>View your orders below.</span>

            </div>
        </div>
        <div style={s.paddingContainer}>
            <div style={s.mobileContainer}>

                {(gettingOrders || authorizing) && <i className={"fas fa-spinner fa-spin"}></i>}
                {(!gettingOrders && !authorizing) && orders.map(order => <div key={order.id}>
                    <Order mini initOrder={order} onClick={() => {
                        window.location.href = `/order?view=${order.id}`;
                    }} key={order.id} order={order} />
                </div>)}
            </div>
        </div>

    </>;
}
export default Orders; 
